



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import InputComponent from '@/components/FormElements/InputComponent.vue';
import LabelComponent from '@/components/FormElements/LabelComponent.vue';
import SelectComponent from '@/components/FormElements/SelectComponent.vue';

@Component({
  components: {
    SelectComponent,
    InputComponent,
    LabelComponent,
  },
})
export default class MultipleAnswerResponse extends Vue {
  @Prop() public readonly value!: string[];
  @Prop(Array) public readonly choices!: string[];

  get selectedChoices() {
    return this.value || [];
  }

  set selectedChoices(newValue) {
    this.$emit('input', newValue);
  }
}
